import { render } from "./SearchLoading.vue?vue&type=template&id=48069087&scoped=true"
import script from "./SearchLoading.vue?vue&type=script&lang=js"
export * from "./SearchLoading.vue?vue&type=script&lang=js"

import "./SearchLoading.vue?vue&type=style&index=0&id=48069087&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48069087"]])

export default __exports__